import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
export const SetupCompletedTaskList = ({ tasks, onCloseModal }) => {
    const { t } = useTranslation();
    return _jsxs(_Fragment, { children: [_jsxs("h4", { className: 'setup-modal__title', children: [_jsx(Icon, { className: 'mr-2', name: 'check' }), t('setup.completedTasks')] }), _jsx("div", { className: 'list-group', children: tasks.map((task) => _jsxs("div", { className: 'setup-modal__task', onClick: () => onCloseModal(task), "data-testid": 'close-modal', children: [_jsx(Icon, { className: 'text-success mr-2', name: 'check-circle' }), " ", task.title] }, task.title)) })] });
};
